import { V2L3LogModal, V2L1LogModalActionButton } from "@fusion-advantage/formrender"
import { useAppSelector, useAppDispatch } from "../../../redux/hooks"
import { ReactNode } from "react"
import { initiateLogin } from "../../../redux/thunk/authThunk"
import { selectSyncResult } from "../../../redux/syncSlice"
import { AppModal, dismissAppModal } from "../../../redux/appSlice"
import { SyncResultStatus } from "@fusion-advantage/formlib"

export const LxLogModal = () => {
	const entries = useAppSelector(state => state.log.entries)
	const rSync = useAppSelector(selectSyncResult)
	const ldng = useAppSelector(state => state.app.ldng.login)
	const working = Boolean((rSync.isErr() && rSync.error.status === SyncResultStatus.Pending) || ldng)
	const dispatch = useAppDispatch()
	let actionNode: ReactNode = null
	if(!working && rSync.isErr() && rSync.error.status === SyncResultStatus.NoAuth) {
		actionNode = <>
			<V2L1LogModalActionButton onClick={() => dispatch(initiateLogin())}>
				Login with Fusion
			</V2L1LogModalActionButton>
			<V2L1LogModalActionButton onClick={() => alert('TODO')}>
				Login with Other
			</V2L1LogModalActionButton>
		</>
	}
	return (
		<V2L3LogModal
			entries={entries}
			actions={actionNode}
			working={working}
			onDismissClick={() => dispatch(dismissAppModal(AppModal.Log))}
		/>
	)
}
